const theme = {
    baseStyle: {
        fontWeight: 'normal',
        backgroundColor: '#ffffff',
        border: '0px',
        rounded: 'lg',
    },
    variants: {
        lesson: {
            panel: {
                border: '0px',
                p: '0'
            },
            button: {
                fontWeight: 'semibold',
                py: '1em',
                color: 'whiteAlpha.900',
                backgroundColor: 'gray.700',
                rounded: 'lg',
                _focus: {
                    boxShadow: 'none'
                }
            }
        },
    },
    defaultProps: {
        colorSheme: 'teal',
        variant: 'lesson',
    }
};

export default theme;